module.exports = __webpack_public_path__ + "img/report_requests_tr.c0715940.png";